/*
 * aqua-family-plp.js
 * Injects a family description module into the product grid on any PLP scoped
 * to a single family (filtered collections/all, or a dedicated family collection).
 * Span + position adapt to the live column count and product count, and the
 * module re-injects on filter change (Section Rendering morph) and on resize.
 * Update-safe: custom asset, no vendor edits. Data comes from aqua-family-plp.liquid.
 */
(function () {
  'use strict';

  var families = [];
  try {
    var dataEl = document.querySelector('script[type="application/json"][data-aqua-families]');
    if (dataEl) families = JSON.parse(dataEl.textContent) || [];
  } catch (e) { families = []; }
  if (!families.length) return;

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  // --- Which family is this page scoped to? -----------------------------------
  function activeFamilyName() {
    var ctx = document.querySelector('[data-aqua-family]'); // dedicated collection (server-side)
    if (ctx && (ctx.getAttribute('data-aqua-family') || '').trim()) {
      return ctx.getAttribute('data-aqua-family').trim();
    }
    var vals = new URLSearchParams(location.search).getAll('filter.p.m.custom.family'); // filtered view
    return vals.length === 1 ? vals[0].trim() : null;
  }

  function familyData(name) {
    var target = name.toLowerCase();
    for (var i = 0; i < families.length; i++) {
      if ((families[i].name || '').trim().toLowerCase() === target) return families[i];
    }
    return null;
  }

  // --- Grid + column count ----------------------------------------------------
  function getGrid() {
    var item = document.querySelector('.product-grid__item:not(.aqua-family-module)');
    return item ? item.parentElement : document.querySelector('.product-grid');
  }
  function columnCount(grid) {
    var tracks = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(function (s) {
      return s && s !== 'none';
    });
    return tracks.length || 1;
  }

  // --- Span + insertion index (per the agreed pattern) ------------------------
  function computeLayout(C, N) {
    var index, span;
    if (C <= 2) {
      index = 3; span = 2;                 // mobile & tablet: after row 1, full width
    } else if (N < C) {
      index = N + 1; span = C - N;         // products fit in <1 row → fill row 1
    } else {
      index = C + 1;                       // otherwise → start of row 2 (never lower)
      var raw = 2 * C - N;
      span = raw <= 0 ? Math.min(3, C) : Math.min(3, raw);
    }
    index = Math.min(index, N + 1);
    span = Math.max(1, Math.min(span, C));
    return { index: index, span: span };
  }
  function layoutClass(span, C) {
    if (span === 1) return 'aqua-fam--textonly';
    if (span === 2) return C <= 2 ? 'aqua-fam--stacked' : 'aqua-fam--split';
    return 'aqua-fam--wide';
  }

  // --- Build the module element ----------------------------------------------
  function sizedImage(baseUrl, w) {
    return baseUrl.replace(/([?&])width=\d+/, '$1width=' + w);
  }
  function buildModule(fam, span, C) {
    var mod = document.createElement('div');
    mod.className = 'product-grid__item aqua-family-module ' + layoutClass(span, C);
    mod.style.gridColumn = 'span ' + span;
    mod.setAttribute('data-aqua-span', span);

    if (fam.image && span > 1) {
      var picWrap = document.createElement('div');
      picWrap.className = 'aqua-family-module__image';
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = fam.name || '';
      img.src = sizedImage(fam.image, 800);
      img.srcset = [400, 600, 800, 1200, 1600].map(function (w) {
        return sizedImage(fam.image, w) + ' ' + w + 'w';
      }).join(', ');
      img.sizes = span >= 3 ? '(min-width: 1200px) 45vw, 90vw' : '(min-width: 750px) 45vw, 90vw';
      picWrap.appendChild(img);
      mod.appendChild(picWrap);
    }

    var text = document.createElement('div');
    text.className = 'aqua-family-module__text';
    
    var h = document.createElement('h2');
    h.className = 'aqua-family-module__glossy h1';
    
    var n = document.createElement('span');
    n.className = 'aqua-family-module__name';
    n.textContent = fam.name || '';
    h.appendChild(n);

    
    if (fam.keywords) {
      var kw = document.createElement('em');
      kw.className = 'aqua-family-module__keywords';
      kw.textContent = fam.keywords;
      h.appendChild(kw);
    }
    
    text.appendChild(h);

    if (fam.description) {
      var d = document.createElement('div');
      d.className = 'aqua-family-module__desc';
      
      var p = document.createElement('p');
      p.textContent = fam.description;
      
      var hh = document.createElement('h6');
      hh.className = 'aqua-family-module__family u-caps';
      hh.textContent = fam.name + ' Family';
      
      d.appendChild(hh);
      d.appendChild(p);
      
      text.appendChild(d);
    }
    mod.appendChild(text);
    return mod;
  }

  // --- Inject / re-inject -----------------------------------------------------
  var busy = false;
  var lastSig = null;

  // A signature of the state the module depends on: family + product count + columns.
  // Excludes the module itself so our own injection doesn't change it (no loop).
  function signature(grid) {
    return (activeFamilyName() || '') + '|' +
      grid.querySelectorAll('.product-grid__item:not(.aqua-family-module)').length + '|' +
      columnCount(grid);
  }

  function apply() {
    if (busy) return;
    var grid = getGrid();
    if (!grid) return;

    busy = true;
    var existing = grid.querySelector('.aqua-family-module');
    if (existing) existing.remove();

    var name = activeFamilyName();
    var fam = name ? familyData(name) : null;
    var items = Array.prototype.filter.call(
      grid.querySelectorAll('.product-grid__item'),
      function (el) { return !el.classList.contains('aqua-family-module'); }
    );
    var N = items.length;

    if (fam && N > 0) {
      var C = columnCount(grid);
      var layout = computeLayout(C, N);
      var mod = buildModule(fam, layout.span, C);
      if (layout.index - 1 < items.length) items[layout.index - 1].before(mod);
      else grid.appendChild(mod);
    }
    lastSig = signature(grid);
    busy = false;
  }

  // --- Wire up ----------------------------------------------------------------
  function init() {
    apply();
    var scope = document.querySelector('.product-grid-container') ||
      document.querySelector('main') || document.body;
    var check = debounce(function () {
      var g = getGrid();
      if (!g) return;
      var name = activeFamilyName();
      var shouldHave = !!(name && familyData(name) &&
        g.querySelector('.product-grid__item:not(.aqua-family-module)'));
      var hasMod = !!g.querySelector('.aqua-family-module');
      // Re-apply when the grid re-renders (family / product-count / column change)
      // or when the module's presence no longer matches what it should be.
      if (signature(g) !== lastSig || shouldHave !== hasMod) apply();
    }, 90);
    new MutationObserver(check).observe(scope, { childList: true, subtree: true });
    window.addEventListener('resize', debounce(apply, 200));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
